import { render, staticRenderFns } from "./addSetSidebar.vue?vue&type=template&id=5ebc2a4e&scoped=true&"
import script from "./addSetSidebar.vue?vue&type=script&lang=js&"
export * from "./addSetSidebar.vue?vue&type=script&lang=js&"
import style0 from "./addSetSidebar.vue?vue&type=style&index=0&id=5ebc2a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebc2a4e",
  null
  
)

export default component.exports